exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GIS_Client .mapstore-filter input::-ms-clear,\r\n.GIS_Client .mapstore-filter input::-ms-reveal {\r\n  display: none;\r\n}\r\n", ""]);

// exports
